import { render, staticRenderFns } from "./StaticPageModalContent.vue?vue&type=template&id=210c2bb2&"
import script from "./StaticPageModalContent.vue?vue&type=script&lang=js&"
export * from "./StaticPageModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports